/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, November 11th 2021, 10:55:26 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { FormControl, InputLabel } from "@mui/material";
import { Select, SelectProps, MenuItem } from "@mui/material";
import { OSFormInputProps, useControlledInput } from "ui-widgets/forms";
import {
  APIFormInputErrorWrapper,
  CustomInputValidationErrorWrapper,
  HelperTextInputWrapper,
} from "ui-widgets/forms/FormInputWrappers";

type DropDownFormInputProps<T> = OSFormInputProps<T> &
  SelectProps & {
    options: { [key: string]: any };
    defaultValue?: string;
    getOptionLabel?: (chosenValue: string) => string;
  };

export const DropDownFormInput = <T,>(props: DropDownFormInputProps<T>) => {
  const {
    controlledProps,
    field: { onChange, value },
  } = useControlledInput<T>(props);

  return (
    <APIFormInputErrorWrapper schema_field_key={props.schema_field_key} label={props.label}>
      <CustomInputValidationErrorWrapper schema_field_key={props.schema_field_key} label={props.label}>
        <HelperTextInputWrapper helperText={props.helperText}>
          <FormControl>
            <InputLabel id={props.labelId}>{props.label}</InputLabel>
            <Select
              {...controlledProps}
              {...props}
              value={value}
              onChange={(event) => {
                onChange(event);
                props.onChange?.(event, false);
              }}
            >
              {Object.keys(props.options).map((k) => (
                <MenuItem key={k} value={k}>
                  {props.getOptionLabel?.(k) ?? props.options[k]}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </HelperTextInputWrapper>
      </CustomInputValidationErrorWrapper>
    </APIFormInputErrorWrapper>
  );
};
